import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../api/client';
import { useAuthStore } from '../store/auth';
import PhoneInput from '../components/PhoneInput';
import PasswordInput from '../components/PasswordInput';

export default function LoginPage() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await apiClient.post('/auth/login', { phone, password });
      if (data.user.role === 'TECHNICIAN') {
        setError('Эта панель предназначена для диспетчеров и администраторов');
        return;
      }
      login(data.accessToken, data.user);
      navigate('/');
    } catch {
      setError('Неверный телефон или пароль');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1>Control Brigade</h1>
        <p className="auth-subtitle">Труба-Дело · диспетчерская панель</p>

        <label>
          Телефон
          <PhoneInput value={phone} onChange={setPhone} />
        </label>
        <label>
          Пароль
          <PasswordInput value={password} onChange={setPassword} autoComplete="current-password" />
        </label>

        {error && <div className="error-text">{error}</div>}

        <button type="submit" disabled={loading}>
          {loading ? 'Входим...' : 'Войти'}
        </button>
      </form>
    </div>
  );
}
